
import React from 'react'
import { useManageExport } from '../export/useManageExport'
import { toast } from 'react-toastify'

const TestInvoice = () => {
    const {exportInvoice, exportMonthlyReports, loading} = useManageExport()

    const handleDownloadInvoice = async () => {
      const result = await exportMonthlyReports();
      if (result === true) {
        toast.success('Invoice downloaded successfully!');
      } else {
        toast.error(`Failed to download invoice: ${result}`);
      }
    };

  return (
    <div>
        <button 
        onClick={() => handleDownloadInvoice('94838')}
        disabled={loading}
      >EXPORT INVOICE</button>
    </div>
  )
}

export default TestInvoice